import { Route } from 'react-router-dom';

import ReadEula from './read-eula/read-eula.component';
import ReadPrivacyPolicy from './read-privacy-policy/read-privacy-policy.component';

export function GeneralInfoRoutes() {
    return (
        <Route path='info'>
            <Route
                path='read-eula'
                element={<ReadEula />}
            />
            <Route
                path='read-privacy-policy'
                element={<ReadPrivacyPolicy />}
            />
        </Route>
    );
}
